import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class CompanyCourseService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('CompanyCourse');
    }

    assign(tempItem: ePM.Logic.CompanyCourseAssign): Observable<boolean> {
        return this.myBaseService.post(tempItem, this.url + "/Assign");
    }
    addToCompany(id: System.Guid): Observable<ePM.Logic.CompanyCourse> {
        return this.myBaseService.post(null, this.url + "/AddToCompany/" + id);
    }
    loadAll(): Observable<ePM.Logic.CompanyCourse[]> {
		return this.myBaseService.loadAll(this.url);
    }
    loadAllAvailable(): Observable<ePM.Logic.CompanyCourse[]> {
        return this.myBaseService.loadAll(this.url + '/All');
    }
	save(tempItem: ECI.Basic.ObjectBase): Observable<ePM.Logic.CompanyCourse> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.CompanyCourse> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<ePM.Logic.CompanyCourse>{
		return this.myBaseService.get(id, this.url);
	}
	
}
				